module.exports = __webpack_public_path__ + "img/icon-checkmark-gradient-border.fa2f2c6.svg";